import { Grid } from "@mui/material";
import { ControlledAutocomplete, FieldControl, PortfolioProjectsAutocomplete } from "../../../../shared/components";

export const Projects = ({ meetingData, onChange, errors = {} }: { meetingData: any, onChange: (key: string, value: any) => void, errors?: { [key: string]: string } }) => {

    return (
        <Grid container spacing={2}>

            <FieldControl
                keyName={"meetingType"}
                label={"Select Type"}
                variant={"radio"}
                value={meetingData.meetingType}
                options={[
                    { value: "projects", label: "Projects" },
                    { value: "programme", label: "Programme" }
                ]}
                onChange={(_key: string, val: string) => onChange('meetingType', val)}
                error={!!errors.meetingType}
                helperText={errors.meetingType}
                required
            />

            {
                meetingData.meetingType !== 'programme' && (
                    <PortfolioProjectsAutocomplete
                        value={meetingData.projects || []}
                        onSelect={(val: any, isChoosedAll: boolean) => {
                            if (isChoosedAll) {
                                onChange('portfolios', val);
                                onChange('projects', null);
                            } else {
                                onChange('portfolios', null);
                                onChange('projects', val);
                            }
                        }}
                        label="Search project"
                        placeholder="Search project"
                        multiSelect
                        error={!!errors.projects}
                        helperText={errors.projects}
                        required
                    />
                )
            }

            {
                meetingData.meetingType === 'programme' && (
                    <ControlledAutocomplete
                        type="PROGRAMME"
                        value={meetingData.programme || []}
                        onSelect={(val) => onChange('programme', val)}
                        label="Search programme"
                        placeholder="Search programme"
                        error={!!errors.programme}
                        helperText={errors.programme}
                        required
                    />
                )
            }

        </Grid>
    );

};